// 文档中心
import axios from '@/libs/api.request'

// 获取左侧组织架构树
export const queryDocTree = () => {
  return axios.request({
    url: '/api/doc/queryDocTree',
    method: 'post'
  })
}

// 获取档案文件列表
export const queryDocFilesPage = (data) => {
  return axios.request({
    url: '/api/doc/queryDocFilesPage',
    method: 'post',
    data
  })
}

// 文件下载-oss
export const ossDownload = (data, params) => {
  return axios.request({
    data: data,
    url: `/api/api/ossDownload`,
    method: 'post',
    ...params
  })
}

// 文件下载-doc
export const download = (data, params) => {
  return axios.request({
    data: data,
    url: `/api/api/download`,
    method: 'post',
    ...params
  })
}

// 文件预览-oss
export const ossPreviewUrl = (data) => {
  return axios.request({
    data: data,
    url: `/api/api/ossPreviewUrl`,
    method: 'post'
  })
}

// 文件预览-doc
export const previewUrl = (data) => {
  return axios.request({
    data: data,
    url: `/api/api/previewUrl`,
    method: 'post'
  })
}

// 文件预览-doc
export const previewUrl2 = (data) => {
  return axios.request({
    data: data,
    url: `/api/api/previewUrl2?id=${data.id}&no=${data.no}`,
    method: 'post'
  })
}

// 获取档案文档编号查列表
export const queryDocFilesByDocumentNo = (data) => {
  return axios.request({
    url: '/api/doc/queryDocFilesByDocumentNo',
    method: 'post',
    data
  })
}
// 文件管理新增文件
export const addDocFilesOnTree = (data) => {
  return axios.request({
    data: data,
    url: `/api/doc/addDocFilesOnTree`,
    method: 'post'
  })
}

// 获取上传文件限制
export const getUploadLimit = (data) => {
  return axios.request({
    data: data,
    url: `/api/api/getUploadLimit`,
    method: 'post'
  })
}
